// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qZGI","label":"styles_label__22OK7"};